import { graphql } from 'relay-runtime';

export const moveTemplateMutation = graphql`
    mutation designTemplatesQueriesMoveTemplateMutation($templateIds: [Long!]!, $categoryId: Long!) {
        moveTemplates(templateIds: $templateIds, categoryId: $categoryId) {
            id
            designTemplateId
            name
            previewUrl

            colors {
                colorID
                name
                isDefault
            }
        }
    }
`;

export const deleteTemplatesMutation = graphql`
    mutation designTemplatesQueriesDeleteTemplatesMutation($modelId: Long!, $templateIds: [Long!]!) {
        deleteTemplates(modelId: $modelId, templateIds: $templateIds) {
            id
            designTemplateId
            name
            previewUrl

            colors {
                colorID
                name
                isDefault
            }
        }
    }
`;

export const setTemplateAsDefaultMutation = graphql`
    mutation designTemplatesQueriesSetTemplateAsDefaultMutation($modelId: Long!, $templateId: ID!, $colorIDs: [Long!]) {
        setTemplateAsDefault(modelId: $modelId, templateId: $templateId, colorIDs: $colorIDs) {
            id
            designTemplateId
            name
            previewUrl

            colors {
                colorID
                name
                isDefault
            }
        }
    }
`;

export const setTemplateAdaptItemToVariants = graphql`
    mutation designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation($modelId: Long!, $templateId: ID!, $type: DesignAdaptAlghoritm!) {
        setTemplateAdaptItemsToVariants(modelId: $modelId, templateId: $templateId, type: $type) {
            id
            designTemplateId
            name
            previewUrl

            colors {
                colorID
                name
                isDefault
            }
        }
    }
`;

export const setShowTemplateSelectionMutation = graphql`
    mutation designTemplatesQueriesSetShowTemplateSelectionMutation($modelID: ID!, $showTemplateSelection: Boolean!) @raw_response_type {
        setShowTemplateSelection(modelID: $modelID, showTemplateSelection: $showTemplateSelection) {
            id
            modelID
            name
            showTemplateSelection
            colors {
                colorID
                name
                colorCode
            }
        }
    }
`;

export const duplicateTemplatesMutation = graphql`
    mutation designTemplatesQueriesDuplicateTemplatesMutation($destProductsIDs: [Long!]!, $templateIDs: [Long!]!) {
        duplicateTemplates(destProductsIDs: $destProductsIDs, templateIds: $templateIDs)
    }
`;
